// This constant is used for Amplitude
export const SCREEN_VIEW = 'ScreenView';
export const ARRIVED_AT_PAYMENT_PAGE = 'ArrivedAtPaymentPage';
export const DISPLAYED_LOCATION_SELECTION = 'DisplayedLocationSelection';
export const DISPLAYED_PRESTATIONS = 'DisplayedPrestations';
export const DISPLAYED_RECAP = 'DisplayedRecap';
